<template>
  <h1 class="title">Правила страхования</h1>
  <section class="container section">
    <div class="card">
      <h3 class="card-title">Раздел 1</h3>
      <p class="card-description">
        Правила обязательного страхования 
        гражданско-правовой ответственности 
        владельцев транспортных средств
      </p>

      <button class="go-to" @click="() => handleOpenPdf('/IR-1.pdf')">
        Подробнее (ОГПО ВТС)
      </button>
    </div>

    <div class="card">
      <h3 class="card-title">Раздел 2</h3>
      <p class="card-description">
        Правила добровольного страхования
        автомобильного транспорта (КАСКО)
      </p>

      <button class="go-to" @click="() => handleOpenPdf('/IR-2.pdf')">
        Подробнее (КАСКО)
      </button>
    </div>

    <div class="card">
      <h3 class="card-title">Раздел 3</h3>
      <p class="card-description">
        Правила добровольного страхования
        гражданско-правовой ответственности 
        владельцев транспортных средств <br/> (ДГПО ВТС)
      </p>

      <button class="go-to" @click="() => handleOpenPdf('/IR-3.pdf')">
        Подробнее (ДГПО ВТС)
      </button>
    </div>
  </section>
</template>

<script setup>
const handleOpenPdf = (pdf_path) => {
    console.log("here")
    window.open(pdf_path, "_blank").focus();
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 300px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  margin-top: 16px;
  margin-bottom: 16px;
  gap: 16px;
}

.title {
  text-align: center;
}

.card {
  color: black;
  display: flex;
  justify-content: start;
  align-items: center;

  padding: 20px;

  height: 100%;

  &-title {
    margin-top: 0;
  }

  &-description {
    text-align: center;
  }

  .go-to {
    margin-top: auto;
    padding: 8px 12px;

    background-color: #4287f5;
    color: white;

    border: none;
    border-radius: 8px;

    cursor: pointer;
  }

  &:hover {
    color: white;
    background: linear-gradient(90deg, #ff143f 0%, #c600dd 49.97%, #1b27ff 100%);
    background: -webkit-gradient(linear, 90deg, #ff143f 0%, #c600dd 49.97%, #1b27ff 100%);
    background: -webkit-linear-gradient(90deg, #ff143f 0%, #c600dd 49.97%, #1b27ff 100%);

    .go-to {
      color: black;
      background-color: white;
    }
  }
}

@media screen and (max-width: 1024px) {
  .section {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
}
</style>
